export default "__VITE_ASSET__8ca8c02c__"